import React, {memo, useCallback, useEffect, useState} from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";
import {
    setSubFormDataAction,clearSubformValidation
} from '../../../../store/actions/formBuilderActions';
import {getHardCodedIds, getSelectedValueFromForm, isSet, setLookupMappingFieldValue} from '../../../../Utils/CommonFunctions';
import SectionFormHeader from "../SectionTypeForm/SectionFormHeader";
import SubFormTable from "./SubFormTable";
import { failMessage, succMessage } from "../../../../store/actions";
import { callPUT } from "../../../../Utils/ApiUtil";
import GroupEditForm from "./GroupEditForm";

const SubFormTypeForm = (props)=>{
    const {index,subformData,modType,pageType,DVis_write,reminderDisplayText} = props;
    const [isSelectAll,setIsSelectAll]=useState(false)
    const [popupToogle,setPopupToogle]=useState(false)
    const [scrollToRowIndex, setScrollToRowIndex] = useState(null)
    const [isTableBusy, setIsTableBusy] = useState(false)

    useEffect(() => {
        if (!isTableBusy) return;
        const id = setTimeout(() => setIsTableBusy(false), 2500);
        return () => clearTimeout(id);
    }, [isTableBusy]);
    const [payload,setPayload]=useState({
        type:"",
        value:""
    })
    const[item,setItem]=useState({})
    // const validationMessages = JSON.parse(JSON.stringify(props.validationForms));
    let isWrite = isSet(DVis_write,true);
    const section = JSON.parse(props.section);
    // console.log('section',section);
    const sectionData = isSet(section.data,[]).map((item)=>{
        if(modType==="DETAILVIEW" && item?.is_detail_view==false || modType==="ADDFORM" && item?.is_add_form==false){
            item.access_mode="HIDDEN";
        }
        return item;
    });
    // const sectionData = section.data;
    const subformIndex = isSet(subformData,[]).findIndex(function(subform) {
        return subform.field_group_section_id == section.id
    });
    const sectionSubformData = (subformIndex>=0)?subformData[subformIndex]:{
        field_group_id: "",
        field_group_section_id:section.id,
        field_group_name:"",
        subform_rows:[]
    };
    let selected_value =[];

    useEffect(()=>{
        // Avoid reseeding while Get latest / merge is in progress — causes index desync
        if(props.isGettingLatestData===true){
          return;
        }
        const indexing = isSet(subformData,[]).findIndex((i)=>i.field_group_section_id===section.id);
        const subformRowsArr = (modType==="DETAILVIEW")?[]:[addNewFormObject()]
        const obj = {
            field_group_id: "",
            field_group_section_id:section.id,
            field_group_name: section.title,
            subform_rows:(isSet(section.subform_rows,[]).length>0)?section.subform_rows:subformRowsArr
        }
        if(indexing==-1){
            props.setSubFormDataAction(modType,[...isSet(subformData,[]),obj]);
        }
        if (
          indexing >= 0 &&
          sectionSubformData.subform_rows.length === 1 &&
          subformData[indexing] &&
          subformData[indexing].subform_rows[0] &&
          subformData[indexing].subform_rows[0].is_selected
        ) {
          selectHandler(0, false)
        }
      },[subformData, props.isGettingLatestData]) 
    //Update subform row in clone / edit
    const  updateSubformRow =()=>{  
        let postData =   isSet(props.subformData,[]);
       const params  = props.match.params;
    if(params.page !== "add"){
        callPUT('table-data-engine/'+params.windowName+'/updateSubformRow/'+params.formId,postData)
    .then(response=>{
        
        if(response.data.code === 200){
            props.succMessage(response.data.message)
        }else{
            props.failMessage(response.data.message)
        }
        
     })
    }
      
   }
    
    // SUBFORM OBJECT
    const addNewFormObject = useCallback((disPos=0)=>{
         //Get selected value from section and store in selected_value array variable.
         if(Object.values(section).length>0){
            isSet(Object.entries(section),[]).map(([item,index])=>{
                if(item === 'data'){
                    index.forEach((data,i)=>{
                    selected_value.push(data);
                    })
                   
                }
            })
        }
        return {
            id: "",
            display_postition: disPos,
            is_selected:false,
            subform_column_values: section.data.map((item, i)=>{
                return{
                    table_descriptor_id:item.id,
                    display_name: item.label.blocks[0].text,
                    selected_value: (item.element==='AutoNumber')?'':isSet(selected_value[i].default_value,''),
                    overridden:false,
                }
            })
        }
    });
   //ADD NEW SUBFORM HANDLER
    const addNewSubForm = useCallback((subformIndex,section)=>{
       
        // console.log('subformIndex',subformIndex);
        if(subformIndex!==-1){
            setIsTableBusy(true);
            // Defer heavy update so Loading can paint first (keeps page responsive)
            const runAfterPaint = () => {
                const nextData = subformData.map((sg, i) =>
                    i === subformIndex
                        ? {
                            ...sg,
                            subform_rows: [...(sg.subform_rows || [])],
                        }
                        : sg
                );
                const rows = nextData[subformIndex].subform_rows;
                const newRow = addNewFormObject(rows.length);
                newRow.isOpenBox = true;
                nextData[subformIndex].subform_rows = [...rows, newRow];
                const addedRowIndex = nextData[subformIndex].subform_rows.length - 1;
                props.setSubFormDataAction(modType, nextData);
                setTimeout(() => setScrollToRowIndex(addedRowIndex), 0);
            };
            if (typeof requestAnimationFrame !== 'undefined') {
                requestAnimationFrame(() => setTimeout(runAfterPaint, 0));
            } else {
                setTimeout(runAfterPaint, 0);
            }
        }else{
            const obj = {
                field_group_id: "",
                field_group_section_id:section.id,
                field_group_name: section.title,
                subform_rows:(section.subform_rows.length>0)?section.subform_rows:[addNewFormObject()]
            }
            props.setSubFormDataAction(modType,[...subformData,obj]);
        }
    });
    let sectionType = isSet(props.sectionType,'Default');
    if(sectionData.length===0){return false} 

    //Hardcoded for myship
    let shouldRenderButton = true;
    const fieldName = 'Package / Pallet';
    const secField = getSelectedValueFromForm({fieldGroups:props.fieldGroups},{
        searchBy:'name',fieldName:fieldName,
        fieldData:{label:fieldName,fieldName:fieldName}
      });
    if(secField.isExist===true && secField.selectedValue===getHardCodedIds('envelopeId')  && section.title==='Package'){
        shouldRenderButton = false;
    }  
    const showTable = section.data.every(item => item.access_mode === "HIDDEN");   

    const selectAll=(val)=>{
        setIsSelectAll(val)
        let updateddata=subformData[subformIndex].subform_rows.map((item)=>{return {...item,is_selected:val}})        
        subformData[subformIndex].subform_rows=updateddata
        props.setSubFormDataAction(modType, [...subformData]);
    }
    const deleteAll=async()=>{
        if(isSelectAll){
          subformData[subformIndex].subform_rows.forEach((val,rowIndex)=>{
                    props.clearSubformValidation(modType, rowIndex);
                })
            subformData[subformIndex].subform_rows = [];
            await props.setSubFormDataAction(modType, [...subformData]);
         await addNewSubForm(subformIndex,section)
         setIsSelectAll(false)
        }else{
            const selecteddata=subformData[subformIndex].subform_rows.filter((item)=>item.is_selected===true)
            if(subformData[subformIndex].subform_rows.length===selecteddata.length){
               selecteddata.forEach((val,rowIndex)=>{
                    props.clearSubformValidation(modType, rowIndex);
                })
                subformData[subformIndex].subform_rows = [];
                await props.setSubFormDataAction(modType, [...subformData]);
                // props.clearFormFieldValidationAction(modType);
              
             await addNewSubForm(subformIndex,section)
             setIsSelectAll(false)
            }else if(selecteddata.length>0 ){
                let updateddata=subformData[subformIndex].subform_rows.filter((item)=>item.is_selected!==true)
                  updateddata.forEach((val,rowIndex)=>{
                    props.clearSubformValidation(modType, rowIndex);
                })
                subformData[subformIndex].subform_rows=updateddata
                props.setSubFormDataAction(modType, [...subformData]);
                
            }
        }
         
    }
    const selectHandler=(ind,val)=>{
        setIsSelectAll(false)
        subformData[subformIndex].subform_rows[ind].is_selected=val
        props.setSubFormDataAction(modType, [...subformData]);
        
    }

    const updatePayload=(updatedval)=>{
      
      if(updatedval.type!==""){
        let data=sectionData.find((item)=>item.id===updatedval.type)
        setItem({ ...(data || {}), selectedValue: "" })
        setPayload(updatedval)
      }else{
        setItem({})
      setPayload(updatedval)
      }

    }
    const saveHandler=()=>{
      
        let updateddata=subformData[subformIndex].subform_rows.map((obj)=> 
        {  let newdata=[]
            let fieldValue=payload.value   
            if(payload.inputType==='Lookup' && obj.is_selected===true){
            let tabescriptorList = [];
            props.fieldGroups.forEach((section)=>{
              isSet(section.data,[]).forEach((ite)=>{
                tabescriptorList.push(ite);
              });
            });            
            const lookupMappingDataa = setLookupMappingFieldValue(obj.subform_column_values,payload.updateData,props.lookupDependency,"subform",tabescriptorList);
            // clearValidationsArr = lookupMappingDataa.clearValidations
            
            newdata = lookupMappingDataa.updatedPreviewItems.map((val)=>{
                if(val.table_descriptor_id===payload.type){
                    val.dpnm=fieldValue?.displayValue;
                    val.selected_value = isSet(fieldValue.selectedValue,fieldValue);
                    val.overridden = true;
              }
              return val
            })
            }else{
              newdata=obj.subform_column_values
            }
             return{  ...obj,
                is_selected:false,
                subform_column_values: payload.inputType==='Lookup' ?newdata                      
                :obj.subform_column_values.map((val)=>{
                if(val.table_descriptor_id===payload.type && obj.is_selected===true){
                                   
                    let inputType = isSet(payload.inputType,"");
                              
                               if(inputType==='Files'){
                                // updateSubformDataState = setLookupMappingFieldValue(updateFieldGroupsState,fieldObj,state.lookupDependency);
                                val.files = fieldValue;
                              }
                              else if(inputType==="Reminder"){
                                val.reminder = fieldValue;
                              }else if(inputType==='currencyType'){
                                val.currency_code = isSet(fieldValue.selectedValue,fieldValue);
                              }else if(inputType==='fromCurrency'){
                                val.from_currency = isSet(fieldValue.selectedValue,fieldValue);
                              }else if(inputType==='exchangeRate'){
                                val.exchange_rate = isSet(fieldValue.selectedValue,fieldValue);
                              }
                              // else if(inputType==='date'){
                              //   updateSubformDataState[fieldObj.subFormIndex].subform_rows[fieldObj.rowIndex].subform_column_values[fieldObj.columnIndex].selected_value = value;
                              // }
                              else{
                                val.selected_value = fieldValue;
                                val.overridden = true;
                    
                              }
                }
                return val
            })
        }
        }
        )        
        subformData[subformIndex].subform_rows=updateddata
        props.setSubFormDataAction(modType, [...subformData]);
        setIsSelectAll(false)
        closePopupToogle()
    }
    const buttonList =   [    {
        clickHandler:()=> closePopupToogle(true),
        type: "edit",
        attributes: {
          className: "btn border-default btn-border",
        },
        svgIcon: "Edit",
         access_mode:sectionSubformData.subform_rows.filter((item)=>item.is_selected===true).length>1?true:false,
      }, {
        clickHandler: deleteAll,
        type: "delete",
        attributes: {
          className: "btn border-default btn-border",
        },
        svgIcon: "Delete",
        title:"delete",
        access_mode:sectionSubformData.subform_rows.filter((item)=>item.is_selected===true).length>1?true:false,
      }]
      const closePopupToogle=(val=false)=>{
        setPopupToogle(val)
        setPayload({
            type:"",
            value:""
      })
      setItem({})
      }
      const showGroupEditDelete=()=>{        
        let updateddata=subformData[subformIndex].subform_rows.filter((item)=>item.is_selected===true)
        if(updateddata.length>1){
            return true
        }else{
            return false
        }
      }
      const changeHandler=(updateData,e,inputType='text')=>{
  
          let fieldValue;
          if(inputType==='PickList'){
            fieldValue = e;
          }else if(inputType==='CheckBoxes'){
            fieldValue = e.target.checked;
          }else if(inputType==='MultiSelect'){
            let MultiSelectValue = [];
            e = (e===null)?[]:e;
            e.map((item)=>{
              MultiSelectValue.push(item.id);
              return item;
            }); 
            fieldValue = MultiSelectValue.join(',');
          }else if(inputType==='Lookup'){
            fieldValue = e;
          }else if(inputType==='number'){
            fieldValue = e; 
          }else if(inputType==='MultiLookup'){
            fieldValue = e; 
          }else if(inputType==='date'){
            fieldValue = e;
          }else if(inputType==='Files'){
            fieldValue = e;
          }else if(inputType==='Reminder'){
            fieldValue = e;
          }else if(inputType==='currencyType'){
            fieldValue = e;
          }else if(inputType==='fromCurrency'){
            fieldValue = e;
          }else if(inputType==='exchangeRate'){
            fieldValue = e;
          }else if(inputType==='phoneNumber'){
            fieldValue = e;
          }else if(inputType==='CustomAllSingle'){
            fieldValue = e;
          }else if(inputType==='CustomAllArray'){
            let MultiArrayValue = [];
            e = (e===null)?[]:e;
            e.map((item)=>{
              MultiArrayValue.push(item.id);
              return item;
            }); 
            fieldValue = MultiArrayValue.join(',');
          }else if(e){
            fieldValue = e.target.value;
          }
        
        setItem((prev)=>{return{...prev,selectedValue:fieldValue}})
        setPayload({
            ...payload,
            value:fieldValue,
            inputType:inputType,
            updateData:updateData
      })
      }
    return (
         showTable? null :
        <div className={(pageType==='view')?'card':'col-12 mb-2'} key={index}>
            <div className="card-outer">
            {
                 sectionType !== 'Steps' ?
                <div className={ isWrite === true ?isSelectAll ? "hide" : "card-tools float-right": "hide"} style={{"position":"relative","zIndex":"1"}}>
                    {shouldRenderButton===true && 
                    <a className="btn m-1" onClick={()=>addNewSubForm(subformIndex,section)}>
                        <i className="fas fa-plus primary_color"></i>
                    </a> 
                    }
                </div>
                :
                null
            }             
            <SectionFormHeader secId={section.id} title={section.title}  showGroupEditDelete={showGroupEditDelete} pageType={pageType} isQuickCreate={props.isQuickCreate} buttonList={buttonList} deleteAll={deleteAll} />
            {/*<div className={`form-body pt-2 p-2 show`} id={'cardDiv'+section.id} style={{}}>*/}
           {popupToogle && <GroupEditForm closePopupToogle={closePopupToogle} item={item} changeHandler={changeHandler} {...props} saveHandler={saveHandler} Fields={section.data} updatePayload={updatePayload} payload={payload} />}
            <div className={`form-body pt-2 show`} id={section.id} style={{}}>
                 <div className="" key={"forms"+index}>
                    <div className="table_Body p-0 table-responsive nowrap" >
                        {!isEmpty(sectionData) && 
                            <SubFormTable 
                                bodyProps={{
                                    modType:modType,
                                    pageType:pageType,
                                    subformData:props.subformData,
                                    onChangeInputAction:props.onChangeInputAction,
                                    sectionSubformData:sectionSubformData,
                                    section:section,
                                    isPopupWindow:props.isPopupWindow,
                                    isWrite:isWrite,
                                    updateFormsInDetailView:props.updateFormsInDetailView,
                                    updateSubformRow:updateSubformRow,
                                    subformIndex:subformIndex,
                                    windowDetails:props.windowDetails,
                                    reminderDisplayText:reminderDisplayText,
                                    sectionType:sectionType,
                                    shouldRenderButton:shouldRenderButton,
                                    isSelectAll:isSelectAll,
                                    selectHandler:selectHandler,
                                    layoutObject:props.layoutObject,
                                    windowName: props.layoutObject?.windowName,
                                    scrollToRowIndex,
                                    onScrolledToRow: () => { setScrollToRowIndex(null); setIsTableBusy(false); },
                                    onSubformRowAdded: (rowIndex) => { setScrollToRowIndex(rowIndex); setIsTableBusy(true); },
                                    showLoadingOverlay: props.layoutObject?.windowName !== 'Shipments' && isTableBusy,
                                    onSubformActionStart: () => setIsTableBusy(true),
                                }}
                                headProps={{
                                    section:section, 
                                    index:index,
                                    isWrite:isWrite,
                                    // sectionData:sectionData,
                                    // validationForms:validationMessages 
                                    validationForms:[],
                                    selectAll:selectAll,
                                    isSelectAll:isSelectAll,
                                    pageType:pageType,
                                    sectionSubformData:sectionSubformData,
                                }}  
                            />
                        }
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
}

const mapDispatchToProps = dispatch => {
    return {
      setSubFormDataAction:(modType,data)=>dispatch(setSubFormDataAction(modType,data)),
      succMessage : (msg) => dispatch(succMessage(msg)),
      failMessage : (msg) => dispatch(failMessage(msg)) ,
      clearSubformValidation: (modType, row) =>
            dispatch(clearSubformValidation(modType, row)),
    };
  }
  const mapStateToProps = (state,props) => { 
    return {
        subformData:state.formBuilder.subformData[props.modType],
        validationForms:state.formBuilder.validationForms[props.modType],
        lookupDependency: state.formBuilder.lookupDependency,
    };
  }
export default
    connect(
      mapStateToProps, 
      mapDispatchToProps
    )(withRouter(memo(SubFormTypeForm)));